import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { z } from "zod";

const responseSchema = z.object({
  data: z.array(z.object({ id: z.string(), title: z.string().nullable() })),
});

// The Files identity projection includes mass-tort members without loading
// complete matter records or their file repositories.
export const retrieveFileSearchMatterTitles = async (
  matterIds: string[],
  signal?: AbortSignal,
) => {
  const titles: Record<string, string> = {};
  for (let start = 0; start < matterIds.length; start += 100) {
    const ids = matterIds.slice(start, start + 100);
    const { data } = await authenticatedFastApiAxiosInstance.post(
      "search/v3",
      {
        entityType: "matter",
        view: "list",
        context: "files",
        filters: { matterIds: ids },
        pageNumber: 1,
        pageSize: ids.length,
      },
      { signal },
    );
    for (const matter of responseSchema.parse(data).data) {
      if (matter.title) titles[matter.id] = matter.title;
    }
  }
  return titles;
};
